import { createContext } from "react";

export interface AuthContextType {
  AuthToken: string;
  setToken: (_token: string) => void;
  unsetToken: () => void;
}

const defaultContextValue: AuthContextType = {
  AuthToken: "",
  setToken: () => {
    // default no-op
  },
  unsetToken: () => {
    // default no-op
  },
};

export const AuthContext = createContext<AuthContextType>(defaultContextValue);
